import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'
import { DownloadService } from './module'

const root = uri => `${LocalStorage.getClientPrefix()}/${uri}`

class ImportExportService {
  importAll (type, file) {
    const formData = new FormData()
    const headers = { 'Content-Type': 'multipart/form-data' }
    const url = `${root(type)}/import-all`

    formData.append('file', file)

    return Api().post(url, formData, { headers })
  }

  exportAll (type, params) {
    const responseType = 'blob'
    const url = `${root(type)}/export-all`

    return Api().post(url, null, { responseType, params })
  }

  export (type, ...args) {
    const responseType = 'blob'
    const url = `${root(type)}/export-item/${args.join('/')}`

    return Api()
      .post(url, null, { responseType })
      .then(({ data }) => DownloadService.downloadContent(`${type}_${args.join('_')}`, data))
  }
}

export default new ImportExportService()
